import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

const PrevNextButton = ({
  onPrev,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false,
  className = "",
  color = "primary", // Default color
  isIconOnly = false, // New prop to control icon-only mode
  size = "medium", // New prop to control button size
}) => {
  const { t } = useTranslation("global");

  // Define size class based on the `size` prop
  const sizeClass = styles[size] || "";

  return (
    <div
      className={`${styles.prevNextButton} ${styles[color]} ${className} ${
        isIconOnly ? styles.iconOnly : ""
      } ${sizeClass}`} // Add size class
    >
      <button
        className={styles.prev}
        onClick={onPrev}
        disabled={isPrevDisabled}
      >
        {isIconOnly ? "" : t("prev")}
      </button>
      <button
        className={styles.next}
        onClick={onNext}
        disabled={isNextDisabled}
      >
        {isIconOnly ? "" : t("booking.nextStep")}
      </button>
    </div>
  );
};

export default PrevNextButton;